import { render, staticRenderFns } from "./PlayerActorList.vue?vue&type=template&id=c76cf402"
import script from "./PlayerActorList.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerActorList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports